import styled from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, styled.h1`
  font-size: 34px;
  line-height: 1.5;
  margin: 0;
  padding: 0;
  font-weight: 300;
  margin-bottom: ${theme.unit * 3}px;
`);



// WEBPACK FOOTER //
// ./src/components/headings/H1.js